module.exports = __webpack_public_path__ + "media/images/partners/business-34974c1f2ce4b90dde6db9cf1e41621e.png";